export default "__VITE_ASSET__BhC3YcIg__"